import styled from "styled-components";
import Button from "../../components/Button";
import { Heading1, Subtitle2 } from "../../components/Typography";
import { COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

const Title = styled.div`
  ${Heading1}
  color: ${COLOR_YELLOW};
`;

const Description = styled.div`
  ${Subtitle2}
  color: ${COLOR_WHITE};
  text-align: center;
`;

function ProductNotFound() {
  return (
    <Container>
      <Title>Product not Found</Title>
      <Description className="mb-3 mb-md-5">The product that you search is not found.</Description>
      <a href="/">
        <Button variant="primary">Back to Home</Button>
      </a>
    </Container>
  );
}

export default ProductNotFound;
